import FormUtente from "./FormUtente";
import {useHistory} from "react-router";
import {useEffect, useState} from "react";
import ApmsService from "../../../services/ApmsService";
import Utils from "../../../utils/Utils";
import Enums from "../../../utils/Enums.json"

function InserisciUtente(props) {

    const history = useHistory()
    const [state, setState] = useState({
        cognome: "",
        nome: "",
        ente: "",
        codiceFiscale: "",
        telefono: "",
        mail: "",
        ruolo: "",
        ultimoLogin: ""
    })
    const [showSpinner, setShowSpinner] = useState(false)
    const [disabledButtonSalvaModifica, setDisabledButtonSalvaModifica] = useState(true)
    const [suggestionsSportelli, setSuggestionsSportelli] = useState([])
    const [gruppiPerApplicazione, setGruppiPerApplicazione] = useState([])
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}

    useEffect(() => {
        Utils.recuperoGruppiPerApplicazione(setShowSpinner,setSuggestionsSportelli,setGruppiPerApplicazione,sessioneUtente)
    }, [])

    function onChange(id, value) {
        let newState = {...state}
        if (id.startsWith("ente")) {
            let selectedOptions = []
            for (let i = 0; i < value.currentTarget.selectedOptions.length; i++) {
                selectedOptions.splice(i, 1, value.currentTarget.selectedOptions[i].value)
            }
            newState[id] = selectedOptions
        } else {
            newState[id] = value
        }
        setState(newState)
        disabledSalvaModifica(newState)
    }

    function disabledSalvaModifica(newState) {
        if (!newState || !newState.cognome || !newState.nome || !newState.ente ||
            !newState.codiceFiscale || !newState.telefono || !newState.mail || !newState.ruolo || (newState.codiceFiscale && !Utils.isCFValid(newState.codiceFiscale))) {
            return setDisabledButtonSalvaModifica(true)
        } else {
            return setDisabledButtonSalvaModifica(false)
        }
    }

    function salvaUtente() {
        setShowSpinner(true)
        let utente = Utils.createJsonUtente(state, suggestionsSportelli, JSON.parse(sessionStorage.getItem("comuniPerCodice")))
        ApmsService.inserisciUtente(utente).then(res => {
            if (res.status === 200) {
                props.getUtenti()
            } else {
                window.alert(Enums.TOASTERTYPE.ERROR.descrizione, "Operazione momentaneamente non disponibile");
                history.push({
                    pathname: "/errore"
                })
            }
            setState({
                cognome: "",
                nome: "",
                ente: "",
                codiceFiscale: "",
                telefono: "",
                mail: "",
                ruolo: "",
                ultimoLogin: ""
            })
            setShowSpinner(false)
            window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione, "Operazione avvenuta con successo");
        }).catch(reason => {
            console.log("Errore Operation POST Utente: " + reason)
            window.alert(Enums.TOASTERTYPE.ERROR.descrizione, "Operazione momentaneamente non disponibile");
            setShowSpinner(false)
        })

    }

    function annullaCreazioneUtente() {
        setState({
            cognome: "",
            nome: "",
            ente: "",
            codiceFiscale: "",
            telefono: "",
            mail: "",
            ruolo: "",
            ultimoLogin: ""
        })
    }


    return (<FormUtente modifica={false} state={state} showSpinner={showSpinner} onChange={onChange}
                        suggestionsSportelli={suggestionsSportelli}
                        onClickAnnulla={annullaCreazioneUtente} onClickSalvaModifica={salvaUtente}
                        disabledButtonSalvaModifica={disabledButtonSalvaModifica}
                        gruppiPerApplicazione={gruppiPerApplicazione}/>)

}

export default InserisciUtente